var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "lead" }, [_vm._v("リンクを取得")]),
    _vm._v(" "),
    _c("div", { staticClass: "urlWrap" }, [
      _c("label", { staticClass: "urlComponent", attrs: { for: "siteUrl" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.url,
              expression: "url"
            }
          ],
          staticClass: "urlComponent__text",
          attrs: { id: "siteUrl", type: "text", placeholder: "URL" },
          domProps: { value: _vm.url },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.url = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "urlCopy button large",
          attrs: {
            "data-clipboard-action": "copy",
            "data-clipboard-target": "#siteUrl"
          },
          on: { click: _vm.copyEvent }
        },
        [_vm._v("コピー")]
      ),
      _vm._v(" "),
      _vm.canGetSiteUrl
        ? _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
            _c(
              "span",
              {
                staticClass: "sitePreview button large",
                attrs: { title: _vm.getSiteUrlTitle() }
              },
              [_vm._v("サイトを見る")]
            )
          ])
        : _c("div", [
            _c(
              "button",
              {
                staticClass: "sitePreview sitePreview--disabled button large",
                attrs: { title: _vm.getSiteUrlTitle() }
              },
              [_vm._v("サイトを見る\n        ")]
            )
          ])
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "copyMessage textOverflow" }, [
      _vm._v(_vm._s(_vm.message))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonDialogPosition" }, [
      _c(
        "button",
        { staticClass: "button large", on: { click: _vm.submitEvent } },
        [_vm._v("閉じる")]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "close-button",
        attrs: { "aria-label": "Close modal", type: "button" },
        on: { click: _vm.close }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }